
import { defineComponent } from 'vue';
import { IInvoice, IOrder } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/invoices';
import TableOrders from './components/invoices/TableOrders.vue';
import TableInvoice from './components/invoices/TableInvoice.vue';
import FormDelivery from './components/invoices/FormDelivery.vue';

const $statusDefault = 'Default';
const $statusDelivered = 'Delivered';
const $statusCancellation = 'Cancellation';

interface IState {
  statusDefault: string;
  statusDelivered: string;
  statusCancellation: string;
  status: string;
  items: IInvoice[];
  defaultCount: number;
  deliveredCount: number;
  cancellationCount: number;
  isTableOrders: boolean;
  isTableInvoice: boolean;
  isFormDelivery: boolean;
  invoice: IInvoice;
  orders: IOrder[];
}

export default defineComponent({
  components: {
    TableInvoice,
    TableOrders,
    FormDelivery,
  },
  data() {
    return {
      statusDefault: 'Default',
      statusDelivered: 'Delivered',
      statusCancellation: 'Cancellation',
      status: this.$route.query.status || 'Default',
      items: [],
      defaultCount: 0,
      deliveredCount: 0,
      cancellationCount: 0,
      isTableOrders: false,
      isTableInvoice: false,
      isFormDelivery: false,
      invoice: {} as IInvoice,
      orders: [],
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          status: this.status,
        },
        (res) => {
          this.items = res.items;
          this.defaultCount = res.defaultCount;
          this.deliveredCount = res.deliveredCount;
          this.cancellationCount = res.cancellationCount;
        },
      );
    },

    apiOrdersGet(invoice: IInvoice) {
      api.getOrders(
        {
          userName: invoice.userName,
          invoiceId: invoice.guid,
        },
        (res) => {
          this.orders = res.orders;
          this.invoice = invoice;
          this.isTableOrders = true;
        },
      );
    },

    apiCancellation(invoice: IInvoice) {
      api.cancellation(
        {
          invoiceId: invoice.id,
          status: this.status,
        },
        (res) => {
          if (!res) return;
          utils.success('发票作废成功！');
          this.apiGet();
        },
      );
    },

    deliverySuccess() {
      this.isFormDelivery = false;
      this.apiGet();
    },

    getInvoiceStatus(status: string) {
      if (status === $statusDefault) {
        return '待开发票';
      }
      if (status === $statusDelivered) {
        return '已寄出';
      }
      if (status === $statusCancellation) {
        return '作废发票';
      }
      return '待开发票';
    },

    btnNavClick() {
      this.apiGet();
    },

    btnOrderClick(invoice: IInvoice) {
      this.apiOrdersGet(invoice);
    },

    btnInvoiceClick(invoice: IInvoice) {
      this.isTableInvoice = true;
      this.invoice = invoice;
    },

    btnDeliverClick(invoice: IInvoice) {
      this.isFormDelivery = true;
      this.invoice = invoice;
    },

    btnCancellationClick(invoice: IInvoice) {
      utils.alertDelete(
        {
          title: '发票作废',
          text: `此操作将把发票${invoice.taxTitle}设置为作废，确定吗？`,
          button: '确认作废',
        },
        () => {
          this.apiCancellation(invoice);
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
